import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {
  createTheme, 
  ThemeProvider, 
  CssBaseline, 
  IconButton,
  useMediaQuery,
  Container,
  Paper,
} from '@mui/material';
import { DarkMode as Moon, LightMode as Sun } from '@mui/icons-material';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Nav from "./components/Nav";
import GoogleAdSense from './components/GoogleAdSense';


export default function App() {

  // useEffect(() => {
  //   const script = document.createElement('script');
  //   script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1693286016749682";
  //   script.async = true;
  //   script.crossOrigin = "anonymous";
  //   document.head.appendChild(script);
  
  //   return () => {
  //     document.head.removeChild(script);
  //   };
  // }, []);

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.type = "text/javascript";

    script1.textContent = `
      atOptions = {
        'key' : 'ec12a1d1c9ef3ce1ad1e2ca8a7e775c5',
        'format' : 'iframe',
        'height' : 250,
        'width' : 300,
        'params' : {}
      };
    `;

    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src = "//www.highperformanceformat.com/ec12a1d1c9ef3ce1ad1e2ca8a7e775c5/invoke.js";

    document.body.appendChild(script1);
    document.body.appendChild(script2);

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);


  const [mode, setMode] = useState(() => 
    localStorage.getItem('themeMode') || 'system'
  )

  // Detect system theme preference
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  // Create theme based on mode
  const theme = createTheme({
    palette: {
      mode: mode === 'system' ? (prefersDarkMode ? 'dark' : 'light') : mode,
    },
  });

  // Toggle between light/dark/system
  const toggleColorMode = () => {
    setMode((prevMode) => {
      let nextMode;
      if (prevMode === 'system') {
        nextMode = prefersDarkMode ? 'light' : 'dark';
      } else if (prevMode === 'light') {
        nextMode = 'dark';
      } else if (prevMode === "dark"){
        nextMode = "light";
      } else {
        nextMode = 'system';
      }
      localStorage.setItem('themeMode', nextMode);
      return nextMode;
    });
  };


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <IconButton
        onClick={toggleColorMode}
        color="inherit"
        sx={{ position: 'absolute', right: 8, top: 16,  }}
      >
        {theme.palette.mode === 'dark' ? <Moon /> : <Sun />}
      </IconButton>

      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
        
        <Nav />
      </Router>

      <Container maxWidth="lg">
        {/* <Paper elevation={3} sx={{ p: 2, my: 2 }}> */}
          {/* <GoogleAdSense /> */}
        {/* </Paper> */}
      </Container>
      
    </ThemeProvider>
  );
}